import React from 'react';
import Layout from '../components/layout';
import Product from '../components/product-components/product';
import { graphql } from 'gatsby';

import SEO from '../components/seo';

const ProductTemplate = ({ data }) => {
    const product = data.product.edges[0].node;
    const wp = data.wp && data.wp.edges[0] && data.wp.edges[0].node;
    const reviews = data.reviews && data.reviews.edges[0] && data.reviews.edges;
    return (
        <Layout>
            <SEO title={product.title} />
            <Product product={product} assets={wp} reviews={reviews} />
        </Layout>
    );
};

export default ProductTemplate;

export const query = graphql`
    query($handle: String!) {
        product: allShopifyProduct(filter: { handle: { eq: $handle } }) {
            edges {
                node {
                    shopifyId
                    id
                    handle
                    title
                    tags
                    productType
                    images {
                        altText
                        localFile {
                            childImageSharp {
                                fluid(maxWidth: 500, quality: 95) {
                                    ...GatsbyImageSharpFluid
                                }
                            }
                        }
                    }
                    priceRange {
                        maxVariantPrice {
                            amount
                        }
                    }
                    descriptionHtml
                    description
                    variants {
                        availableForSale
                        compareAtPrice
                        id
                        shopifyId
                        image {
                            originalSrc
                            altText
                        }
                        price
                        selectedOptions {
                            name
                            value
                        }
                    }
                }
            }
        }
        wp: allWpProductsWp(
            filter: { pdp_acf: { productHandle: { eq: $handle } } }
        ) {
            edges {
                node {
                    title
                    pdp_acf {
                        productDescription
                        productDescriptionTitle
                        productHandle
                        productContentRows {
                            contentRowDescription
                            contentRowTitle
                            contentRowImage {
                                localFile {
                                    childImageSharp {
                                        fluid(maxWidth: 1000, quality: 95) {
                                            ...GatsbyImageSharpFluid
                                        }
                                    }
                                }
                            }
                        }
                        relatedProductsCollectionHandle
                        productContentTiles {
                            tileHoverColor
                            tileLink {
                                title
                                url
                            }
                            tileImage {
                                localFile {
                                    childImageSharp {
                                        fluid(maxWidth: 1000, quality: 95) {
                                            ...GatsbyImageSharpFluid
                                        }
                                    }
                                }
                            }
                            tileShortDescription
                        }
                        isProductColormatchChart
                        productSplitSectionSettings {
                            splitSectionCaption
                            splitSectionTitle
                            splitSectionImage {
                                localFile {
                                    childImageSharp {
                                        fluid(maxWidth: 1000) {
                                            ...GatsbyImageSharpFluid
                                        }
                                    }
                                }
                            }
                            splitSectionButton {
                                title
                                url
                            }
                            splitSectionIcons {
                                iconBlurb
                                iconTitle
                                iconImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 100) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        productVideoSettings {
                            videoCaption
                            videoLinkText
                            videoSource
                            videoTitle
                            videoImage {
                                localFile {
                                    childImageSharp {
                                        fluid(maxWidth: 1000) {
                                            ...GatsbyImageSharpFluid
                                        }
                                    }
                                }
                            }
                        }
                        productBlogFeed {
                            blogCategoryHandle
                            sectionTitle
                        }
                    }
                }
            }
        }
        reviews: allGoogleSheetSheet1Row(
            filter: { producthandle: { eq: $handle } }
        ) {
            edges {
                node {
                    date
                    producthandle
                    reviewername
                    email
                    stars
                    reviewtitle
                    reviewbody
                }
            }
        }
    }
`;
